import React, { useState } from 'react';

import WpAnnouncementContainer from '../WpAnnouncementContainer';
import { WpButton } from '../../button';

const AnnoucementContainerDocs = () => {
  const [colors, setColors] = useState(['gray', 'purple']);

  const handleDismiss = color => {
    setColors(colors.filter(c => c !== color));
  };

  return (
    <>
      {colors.map(color => (
        <div style={{ marginBottom: '2rem' }}>
          <WpAnnouncementContainer
            image="https://piprodperformassets.blob.core.windows.net/assets/charma_floders.png"
            title="Hello World!"
            text="Welcome, I'm an annoucement container that can be used for a light weight introduction to features in the app!"
            onDismiss={() => handleDismiss(color)}
            // @ts-ignore
            color={color}
            button={
              <WpButton size="sm" variant="tertiary">
                Learn More
              </WpButton>
            }
          />
        </div>
      ))}
    </>
  );
};

export default AnnoucementContainerDocs;
